<template>
    <Form inline populateType="chain" :value="list" ref="rentDiscount">
        <Row :gutter="20" v-if="list.length" style="margin-bottom: 11px">
            <Col span="24">
                <FormItem>
                    <check-tag-group
                        style="display: inline-block"
                        :value="arrDiscountType"
                        color="primary"
                        @on-change="changeDiscountType"
                    >
                        <check-tag
                            v-for="item in dict.discountType.toList()"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem>
            </Col>
        </Row>
        <!-- 按合同月付 -->
        <template v-if="discountType == 3">
            <field-group
                v-for="(item, index) in list"
                :key="index"
                :model="item"
                :rules="rulesOfPeriodMonth"
                class="rent-item"
            >
                <FormItem class="rent-field" prop="period">
                    <Select
                        v-model="item.period"
                        transfer
                        placeholder="请选择账期"
                        @on-change="onItemPeriodChange(item, $event)"
                        style="width: 230px"
                    >
                        <Option
                            v-for="p in periodList"
                            :value="p.period"
                            :key="p.period"
                        >
                            第{{ p.period }}期 ({{ p.startDate }} 至
                            {{ p.endDate }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem v-show="finalViewonly" prop="monthText">
                    <Input
                        :value="item.monthText"
                        :style="{ width: (item.monthText ? 230 : 0) + 'px' }"
                    ></Input>
                </FormItem>
                <FormItem class="rent-field" prop="month">
                    <Select
                        v-show="!finalViewonly"
                        v-model="item.month"
                        transfer
                        placeholder="请选择合同月"
                        style="width: 230px"
                        :loading="item.monthLoading"
                        @on-option-click="onItemMonthOptionClick(item, $event)"
                    >
                        <Option
                            v-for="p in item.monthList"
                            :value="p.month"
                            :key="p.month"
                        >
                            第{{ p.month }}个月 ({{ p.startDate }} 至
                            {{ p.endDate }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem prop="remark">
                    <Input
                        v-model="item.remark"
                        placeholder="备注"
                        style="width: 230px"
                    >
                    </Input>
                </FormItem>
                <span v-if="finalEditable" class="rent-cut" @click="cut(index)">
                    -
                </span>
            </field-group>
        </template>
        <!-- 按天优惠、按金额优惠 -->
        <template v-else>
            <field-group
                v-for="(item, index) in list"
                :key="index"
                :model="item"
                :rules="innerRules"
                class="rent-item"
            >
                <FormItem class="rent-field" prop="startDate">
                    <DatePicker
                        placeholder="请输入开始日期"
                        v-model="item.startDate"
                        type="date"
                        style="width: 125px"
                        @on-change="dateChange(index)"
                    />
                </FormItem>
                <span class="rent-text">至</span>
                <FormItem class="rent-field" prop="endDate">
                    <DatePicker
                        placeholder="请输入结束日期"
                        v-model="item.endDate"
                        type="date"
                        style="width: 125px"
                        @on-change="dateChange(index)"
                    />
                </FormItem>
                <span class="rent-text">优惠</span>
                <FormItem class="rent-field" prop="amount">
                    <input-number
                        v-model="item.amount"
                        type="date"
                        style="width: 150px"
                        :disabled="isDay"
                        :allowDecimal="!isDay"
                    >
                        <span slot="append">{{ isDay ? '天' : '元' }}</span>
                    </input-number>
                </FormItem>
                <FormItem class="rent-field" prop="remark">
                    <Input
                        v-model="item.remark"
                        style="width: 300px"
                        placeholder="备注文字"
                    />
                </FormItem>
                <span v-if="finalEditable" class="rent-cut" @click="cut(index)">
                    -
                </span>
            </field-group>
        </template>
        <div
            v-if="
                finalEditable && $can('discount', 'api/contract/info?type=zz')
            "
            style="line-height: 30px"
        >
            <div class="rent-add" @click="add">
                <span class="rent-add-plus">+</span>添加优惠
            </div>
        </div>
    </Form>
</template>
<script>
// 优惠费用
import { Field } from 'ivux'
import { ymd } from '_u/helper'
import { getPeriods } from '@/api/contract'

export default {
    name: 'RentDiscount',

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        // 优惠方式
        discountType: {
            type: [String, Number],
            default: '',
        },
        // 约定租期开始日期
        startDate: {
            type: [String, Date],
            default: '',
        },
        // 预订租期结束日期
        endDate: {
            type: [String, Date],
            default: '',
        },
        // 交租方式(租金)
        rentPayMethod: {
            type: [String, Number],
            default: '',
        },
        populateType: {
            type: String,
            default: 'through',
        },
        // 账期合并列表
        mergeList: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inited: false,
            list: this.value,
            dict: {
                discountType: this.$dict.NULL,
            },
            num: 1000 * 60 * 60 * 24,
            periodList: [], // 合同账期列表
        }
    },

    watch: {
        value(val) {
            this.setData(val)
        },

        list: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },

        discountType(val) {
            if (this.inited) {
                this.resetList()
            }
        },
    },

    computed: {
        arrDiscountType() {
            return this.discountType ? [this.discountType] : []
        },
        innerRules() {
            var rules = {
                startDate: [
                    { required: true, message: '开始时间必填' },
                    { validator: this.checkEndTime },
                ],
                endDate: [{ required: true, message: '结束时间必填' }],
                amount: [{ required: true, message: '优惠金额必填' }],
            }

            // 按天优惠
            if (this.discountType === '1') {
                rules.endDate.push({
                    validator: this.checkUniqueOfDay,
                })
            }

            // 按金额优惠
            if (this.discountType === '2') {
                rules.amount.push({
                    validator: this.checkUniqueOfAmount,
                })
            }

            return rules
        },

        rulesOfPeriodMonth() {
            return {
                month: [{ validator: this.checkUniqueOfPeriod }],
            }
        },

        isDay() {
            return this.discountType === '1'
        },
    },

    created() {
        this.fetch()

        // 联动查询合同账期
        this.$watch(
            function () {
                return (
                    '' +
                    this.discountType +
                    this.startDate +
                    this.endDate +
                    this.rentPayMethod +
                    this.mergeList
                )
            },
            function (val) {
                if (
                    this.discountType == 3 && // 按合同月优惠
                    !!this.startDate &&
                    !!this.endDate &&
                    !!this.rentPayMethod
                ) {
                    if (this.inited) {
                        this.resetList()
                    }
                    this.fetchPeriods()
                }
            },
            {
                immediate: true,
            }
        )
    },

    methods: {
        fetch() {
            Promise.all([this.$dict.get(['discount_type'])]).then((args) => {
                var [group] = args
                Object.assign(this.dict, group)
            })
        },

        // 获取账期
        fetchPeriods() {
            return getPeriods({
                startDate: ymd(this.startDate),
                endDate: ymd(this.endDate),
                rentPayMethod: this.rentPayMethod,
                mergeList: this.mergeList,
            }).then((res) => {
                this.periodList = res.data.periodList
            })
        },

        getCurrentValue() {
            return []
        },

        setData(list) {
            this.list = [...list]
        },

        // 重置列表数据
        resetList() {
            this.list = []
            this.add()
        },

        onItemPeriodChange(item, e) {
            item.monthLoading = true
            item.month = ''
            item.monthList = []
            item.monthText = ''

            // 查询当行合同月列表
            getPeriods({
                startDate: ymd(this.startDate),
                endDate: ymd(this.endDate),
                rentPayMethod: this.rentPayMethod,
                period: e,
                mergeList: this.mergeList,
            })
                .then((res) => {
                    item.monthList = res.data.monthList
                })
                .finally(() => {
                    item.monthLoading = false
                })
        },

        onItemMonthOptionClick(item, option) {
            item.monthText = option.label
        },

        // 截止日期不能大于开始日期
        checkEndTime(rule, value, callback, source, options) {
            if (source.startDate && source.endDate) {
                console.log(
                    source.endDate.getTime() < source.startDate.getTime()
                )
                if (source.endDate.getTime() < source.startDate.getTime()) {
                    callback(new Error('开始日期不能大于截止日期'))
                }
            }

            callback()
        },

        // 优惠天数不能重复
        checkUniqueOfDay(rule, value, callback, source) {
            if (
                this.list.filter(
                    (v) =>
                        v.startDate &&
                        v.endDate &&
                        v.startDate.getTime() === source.startDate.getTime() &&
                        v.endDate.getTime() === source.endDate.getTime()
                ).length >= 2
            ) {
                callback(new Error('优惠区间不能重复'))
            } else {
                callback()
            }
        },

        // 优惠金额不能重复
        checkUniqueOfAmount(rule, value, callback, source) {
            if (
                this.list.filter(
                    (v) =>
                        v.startDate &&
                        v.endDate &&
                        v.startDate.getTime() === source.startDate.getTime() &&
                        v.endDate.getTime() === source.endDate.getTime() &&
                        v.amount === source.amount
                ).length >= 2
            ) {
                callback(new Error('优惠区间+金额不能重复'))
            } else {
                callback()
            }
        },

        // 账期+合同月不能重复
        checkUniqueOfPeriod(rule, value, callback, source) {
            if (
                this.list.filter(
                    (v) =>
                        v.period &&
                        v.month &&
                        v.period === source.period &&
                        v.month === source.month
                ).length >= 2
            ) {
                callback(new Error('账期+合同月不能重复'))
            } else {
                callback()
            }
        },

        createItem() {
            // 按合同月付
            if (this.discountType == 3) {
                return {
                    period: '',
                    month: '',
                    remark: '',
                    monthList: [],
                    monthText: '',
                    monthLoading: false,
                }
            }

            // 按天优惠、按金额优惠
            return { startDate: '', endDate: '', amount: 0, remark: '' }
        },

        add() {
            this.list.push(this.createItem())
        },

        cut(i) {
            this.list.splice(i, 1)
        },

        // 租金优惠方式发生更改
        changeDiscountType(arr) {
            this.$emit('on-type-change', arr[0])
            this.inited = true
        },

        // 日期更改
        dateChange(index) {
            this.$refs.rentDiscount.validate()
            if (this.isDay) {
                const item = this.list[index]
                console.log(item)
                if (item.startDate && item.endDate) {
                    item.amount = (item.endDate - item.startDate) / this.num + 1
                } else {
                    item.amount = 0
                }
            }
        },
    },
}
</script>
<style lang="less" scoped>
.rent {
    &-item {
        margin-bottom: 18px;
    }

    &-field {
        flex-basis: 20px;
    }

    &-text {
        margin-right: 10px;
    }

    &-cut {
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
